import { AbstractControl, ValidationErrors } from '@angular/forms';

export function claimsFieldValidatorFn(control: AbstractControl): ValidationErrors | null {
  const forbidden = control.value ? control.value.match(/\|;/) : false;
  return forbidden ? { claimField: true } : null;
}
